export const INITIAL_BALANCES_REQUEST = "INITIAL_BALANCES_REQUEST";
export const FETCH_BALANCES_SUCCESS = "FETCH_BALANCES_SUCCESS";
